import i18nFactory from '@yandex-int/i18n';

import { castStringToEnum } from '../../service/CastHelpers';
import { ValidationErrorData } from '../../typings/common';
import { GdContentLanguage } from '../../typings/graphql-grid';

import * as keyset from './BannersLang.i18n';
const i18n = i18nFactory(keyset);

const NOT_SET_VALUE = 'notSet';

export type LanguageDropdownItemId = GdContentLanguage | typeof NOT_SET_VALUE;

const bannerLangMap = {
    [GdContentLanguage.RU]: i18n('ru'),
    [GdContentLanguage.UA]: i18n('ua'),
    [GdContentLanguage.KZ]: i18n('kz'),
    [GdContentLanguage.TR]: i18n('tr'),
    [GdContentLanguage.EN]: i18n('en'),
    [GdContentLanguage.DE]: i18n('de'),
    [GdContentLanguage.BE]: i18n('be')
};

export interface LanguageDropdownItem {
    id: LanguageDropdownItemId;
    name: string;
}

export interface LanguageDropdownParams {
    selectedId: LanguageDropdownItemId;
    label: GdContentLanguage | string;
    items: LanguageDropdownItem[];
    errors?: ValidationErrorData[];
}

export const getBannerLangText = (lang: GdContentLanguage): string => {
    if (bannerLangMap[lang] === undefined) {
        throw new Error(`Язык ${lang} не поддерживается`);
    }

    return bannerLangMap[lang];
};

export const getBannerLangDropdownId = (
    selectedLanguage?: GdContentLanguage
): LanguageDropdownItemId => {
    return selectedLanguage || NOT_SET_VALUE;
};

export const getBannerLangDropdownLabel = (
    selectedLanguage?: GdContentLanguage
): GdContentLanguage | string => {
    return selectedLanguage === undefined
        ? i18n('language-not-set')
        : getBannerLangText(selectedLanguage);
};

export const getBannerLangDropdownItems = (): LanguageDropdownItem[] => {
    const supportedLanguages = Object.keys(bannerLangMap).map(key =>
        castStringToEnum(key, GdContentLanguage)
    );

    const items: LanguageDropdownItem[] = supportedLanguages.map(
        languageCode => {
            return {
                id: languageCode,
                name: getBannerLangText(languageCode)
            };
        }
    );

    items.unshift({
        id: NOT_SET_VALUE,
        name: i18n('language-not-set')
    });

    return items;
};

export const getSelectedLanguageValue = (
    value: LanguageDropdownItemId
): GdContentLanguage | undefined => {
    return value === NOT_SET_VALUE ? undefined : value;
};
